/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * How the Play's Checklist is configured:
 *
 * - NONE: There is no Checklist for this Play.
 * - USE_DEFAULT: The Checklist is automatically generated based on the content.
 * - CUSTOM: This Play has a custom Checklist.
 *
 */
export enum PlayChecklistMode {
    USE_DEFAULT = 'USE_DEFAULT',
    CUSTOM = 'CUSTOM',
    NONE = 'NONE',
}
